'use client';

import { useEffect } from 'react';
import { scrollToId } from '@/libs/scroll';

/**
 * Fix universal para los anchors `href="#id"` de todo el sitio: el navegador
 * solo hace scroll la primera vez (si el hash ya está en la URL, no re-scrollea).
 * Este handler global intercepta cualquier click en un ancla de la misma página
 * y hace scroll suave siempre, vía `scrollToId` (que respeta el
 * `scroll-padding-top: var(--nav-h)` del html → el destino topa con el navbar).
 *
 * Se monta una vez en el layout. No requiere tocar cada ancla ni convertir
 * componentes server en client. Los `<button onClick={() => scrollToId(...)}>`
 * (ej. la flecha del hero) usan el mismo helper directamente.
 */
export default function HashScroll() {
  useEffect(() => {
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      scrollToId(href, e); // preventDefault + scroll suave (maneja '#' y '#id')
      if (href && href !== '#') history.replaceState(null, '', href);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return null;
}
